import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=0104b456&scoped=true&"
import script from "./main-footer.vue?vue&type=script&lang=js&"
export * from "./main-footer.vue?vue&type=script&lang=js&"
import style0 from "./main-footer.vue?vue&type=style&index=0&id=0104b456&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0104b456",
  null
  
)

export default component.exports